// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCollapsibleSection-Checkbox_cls1__J1lqp","cls2":"VeloCollapsibleSection-Checkbox_cls2__Pz8CE VeloCollapsibleSection-Checkbox_cls1__J1lqp"};